import { render, staticRenderFns } from "./PdfClaimPopup.vue?vue&type=template&id=5b492bb2"
import script from "./PdfClaimPopup.vue?vue&type=script&lang=js"
export * from "./PdfClaimPopup.vue?vue&type=script&lang=js"
import style0 from "./PdfClaimPopup.vue?vue&type=style&index=0&id=5b492bb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports